import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { appStore } from "./store/Store";
import reportWebVitals from "./reportWebVitals";

// Suppress benign ResizeObserver loop errors from triggering the development error overlay
if (typeof window !== "undefined") {
  window.addEventListener(
    "error",
    (e) => {
      const msg = e?.message || "";
      if (
        typeof msg === "string" &&
        (msg.includes("ResizeObserver loop") ||
          msg.includes("undelivered notifications"))
      ) {
        e.stopImmediatePropagation();
        e.stopPropagation();
      }
    },
    true,
  );

  const origOnError = window.onerror;
  window.onerror = (msg, url, lineNo, columnNo, error) => {
    if (
      typeof msg === "string" &&
      (msg.includes("ResizeObserver loop") ||
        msg.includes("undelivered notifications"))
    ) {
      return true;
    }
    if (origOnError) {
      return origOnError(msg, url, lineNo, columnNo, error);
    }
    return false;
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={appStore}>
    <App />
  </Provider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
